import { ImageLoader } from "@src/helpers/ImageLoader";
import ImageResolution from "@src/saunaparts/ImageResolution";


export class ColorLayer
{
    imagePath:string;
    color:string;
    context:CanvasRenderingContext2D;
    constructor(imagePath:string,color:string,context:CanvasRenderingContext2D)
    {
        this.imagePath= imagePath;
        this.color= color;
        this.context= context;
    }
    Render(resolution: ImageResolution): Promise<CanvasRenderingContext2D> {
        return new ImageLoader(this.imagePath).Load().then((image)=>{
            return this.applyColor(image,resolution);
        })     
    }
     applyColor(baseImage:HTMLImageElement,resolution: ImageResolution):CanvasRenderingContext2D {      
        let mask  = this.buildMask(baseImage,resolution);    
            this.context.drawImage(baseImage,0,0,resolution.width,resolution.height);
            this.context.globalCompositeOperation = "multiply";
            this.context.drawImage(mask,0,0,resolution.width,resolution.height);
            this.context.globalCompositeOperation = "source-over";
            return this.context;
    }
    buildMask(baseImage:HTMLImageElement,resolution:ImageResolution):HTMLCanvasElement
    {
        let mask = document.createElement("canvas");
        mask.width= resolution.width;
        mask.height= resolution.height;
        let context = mask.getContext("2d");
        if(context)
        {
            context.imageSmoothingEnabled= false;
            context.drawImage(baseImage,0,0,resolution.width,resolution.height);
            context.globalCompositeOperation = "source-in"; 
            context.fillStyle = this.color;
            context.fillRect(0,0,resolution.width,resolution.height);
            return mask;    
        }
        else
        {
            throw "Failed to create context";
        }
    }
}